import { render, staticRenderFns } from "./ComingSoon.vue?vue&type=template&id=54c75004&"
import script from "./ComingSoon.vue?vue&type=script&lang=ts&"
export * from "./ComingSoon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54c75004')) {
      api.createRecord('54c75004', component.options)
    } else {
      api.reload('54c75004', component.options)
    }
    module.hot.accept("./ComingSoon.vue?vue&type=template&id=54c75004&", function () {
      api.rerender('54c75004', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/ComingSoon.vue"
export default component.exports